import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { AttainmentBar } from 'ui-deal-management-components-lib/components/attainmentBar/AttainmentBar';
import { GOAL_TYPE_FORMAT_CONFIG } from '../../../../config/goalTypeFormatConfig';
export default function PercentProgress({
  goalTarget
}) {
  const goalTypeFormatConfig = GOAL_TYPE_FORMAT_CONFIG(goalTarget);
  return /*#__PURE__*/_jsx(AttainmentBar, {
    goal: Number(goalTarget.goalTargetAmount),
    renderGoal: goal => /*#__PURE__*/_jsxs(Small, {
      "data-test-id": "progress-of-text",
      use: "help",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.table.headers.progressOfTagline"
      }), goalTypeFormatConfig[goalTarget.goalType].formatTargetAmount(goal)]
    }),
    renderValue: value => /*#__PURE__*/_jsx(Small, {
      "data-test-id": "target-amount-text",
      use: "help",
      children: goalTypeFormatConfig[goalTarget.goalType].formatTargetAmount(value)
    }),
    value: goalTarget.kpiValue || 0
  });
}